import React from 'react';
import PropTypes from 'prop-types';
import { opportunityPropType } from 'constants/propTypes';
import Button from 'components/Button';
import { DropdownPillMenu } from 'components/Dropdown';
import { TodayTomorrowWeekday } from 'components/IntlHelpers';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';
import icon from 'static/img/Core/recommendation-icon.svg';
import { messages } from '../messages';

const { element } = bem('opportunities');

const Row = ({ availabilityDropdownRange, onAcceptOpportunity, opportunity, setSpotsToAdd, spotsToAdd }) => {
  const { classDisabledDueToPricingOptions, className, recommendation, startDateTime, teacherName } = opportunity;

  return (
    <div className={element('row-wrap')}>
      <div className={element('class-info', 'mb-l lg-mb-0')}>
        <Message format="time" value={startDateTime} />
        <Message
          className="opportunities__day-and-date"
          message={messages.dayAndDate}
          values={{
            date: startDateTime,
            day: <TodayTomorrowWeekday key={startDateTime} date={startDateTime} />,
          }}
        />
        <div>{className}</div>
        <div className="opportunities__teacher-info">{teacherName}</div>
      </div>

      <div className={element('prediction', 'pl-h mb-r lg-mb-0')}>
        <Message
          as="div"
          message={classDisabledDueToPricingOptions ? messages.pricingOptionIssue : messages.fillPrediction}
          values={{
            spots: recommendation,
            a: text => (
              <a
                href="https://support.mindbodyonline.com/s/article/203253823-Pricing-options-memberships"
                target="_blank"
                rel="noopener noreferrer">
                {text}
              </a>
            ),
          }}
        />
      </div>

      <div className={element('controls-wrap', 'ml-h lg-ml-0')}>
        <div className={element('button-wrap')}>
          <DropdownPillMenu
            className="mr-r"
            attachment="right"
            items={availabilityDropdownRange.map(i => ({
              key: i,
              label: i,
              icon: i === recommendation ? icon : false,
            }))}
            getText="label"
            getKey="key"
            isSelected={available => available.key === spotsToAdd}
            onSelect={available => setSpotsToAdd(opportunity.scheduleId, available.key)}
            renderAsActive={false}
          />
          <Message
            as={Button}
            className="bt--sm"
            type={Button.TYPES.BUTTON}
            styled="primary-outline"
            onClick={() => onAcceptOpportunity(opportunity, spotsToAdd)}
            message={messages.enableBtnPlus}
            values={{ spots: spotsToAdd }}
          />
        </div>
      </div>
    </div>
  );
};

Row.propTypes = {
  availabilityDropdownRange: PropTypes.arrayOf(PropTypes.number),
  onAcceptOpportunity: PropTypes.func,
  opportunity: opportunityPropType.isRequired,
  setSpotsToAdd: PropTypes.func,
  spotsToAdd: PropTypes.number,
};

export default Row;
